export default __webpack_public_path__ + "static/media/flbtm.330a8a0c.svg";